import { render, staticRenderFns } from "./StorageSpaceMediaInfo.vue?vue&type=template&id=949b1bae&"
import script from "./StorageSpaceMediaInfo.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports